import {
  TABLE_HEADER_ATHLETE,
  TABLE_HEADER_ATHLETE_FREE_FORM,
} from "constants/dashboard";
import { SortConfig } from "types/common";
import { TableHeaderButton } from "./TableHeaderButton";

type Props = {
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
  isFreeForm: boolean;
};
export const AthleteTableHeader = ({
  onClick,
  sortConfig,
  isFreeForm,
}: Props) => {
  const TABLE_HEAD = isFreeForm
    ? TABLE_HEADER_ATHLETE_FREE_FORM
    : TABLE_HEADER_ATHLETE;
  return (
    <div>
      <div className="w-full flex items-center text-grayDark text-[10px] px-3 mb-2.5 ">
        {TABLE_HEAD.map((item) => {
          const isLastAvg = item.sortBy === "lastExamAvg";
          const handleClick = () => {
            onClick(item.sortBy);
          };
          return (
            <div
              key={item.title}
              className="space-x-1 text-left  relative"
              style={
                isLastAvg
                  ? {
                      backgroundColor: "rgb(255 181 0)",
                      borderRadius: "12px",
                      width: "fit-content",
                    }
                  : { width: item.width }
              }
            >
              {item.title && (
                <TableHeaderButton
                  handleClick={handleClick}
                  item={item}
                  sortConfig={sortConfig}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
